import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "navbar-nav" }
const _hoisted_2 = { class: "nav-item dropdown" }
const _hoisted_3 = {
  class: "nav-link dropdown-toggle d-flex align-items-center",
  "data-bs-toggle": "dropdown",
  href: "#",
  role: "button",
  "aria-expanded": "false"
}
const _hoisted_4 = {
  key: 0,
  class: "small"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "dropdown-menu dropdown-menu-end" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 2,
  class: "px-3 py-2"
}
const _hoisted_10 = { class: "d-flex align-items-center justify-content-between flex-nowrap" }
const _hoisted_11 = { class: "form-check form-switch m-0" }
const _hoisted_12 = ["checked"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    _createElementVNode("li", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: _normalizeClass(["position-relative small", _ctx.isVIP ? 'me-3' : 'me-2']),
          style: {"max-width":"36px"}
        }, [
          (_ctx.isVIP)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, [...(_cache[2] || (_cache[2] = [
                _createElementVNode("span", { class: "position-absolute top-90 start-100 translate-middle badge rounded-pill vip-badge" }, "Win", -1)
              ]))]))
            : _createCommentVNode("", true),
          _createElementVNode("img", {
            class: _normalizeClass(["rounded-circle img-fluid border border-1 gtr-avatar-bg", 
              _ctx.isVIP ? 'vip-stroke vip-shadow' : 'avatar-shadow border-secondary'
            ]),
            alt: "Profile picture",
            src: _ctx.getUserPicture
          }, null, 10, _hoisted_5)
        ], 2),
        _createElementVNode("div", null, _toDisplayString(_ctx.getUserNickname), 1)
      ]),
      _createElementVNode("ul", _hoisted_6, [
        (_ctx.canAccess('profile'))
          ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
              _createVNode(_component_router_link, { to: "/profile" }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createElementVNode("a", {
                    href: "#",
                    class: "dropdown-item"
                  }, [
                    _createElementVNode("i", { class: "fas fa-user text-blue me-2" }),
                    _createElementVNode("span", { class: "nav-link-text" }, "Mi Perfil")
                  ], -1)
                ]))]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.userFlagsStore.canAccessAdminView)
          ? (_openBlock(), _createElementBlock("li", _hoisted_8, [...(_cache[4] || (_cache[4] = [
              _createElementVNode("hr", { class: "dropdown-divider" }, null, -1)
            ]))]))
          : _createCommentVNode("", true),
        (_ctx.userFlagsStore.canAccessAdminView)
          ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _cache[5] || (_cache[5] = _createElementVNode("div", { class: "me-3 text-nowrap" }, [
                  _createElementVNode("i", { class: "fas fa-user-shield me-2" }),
                  _createElementVNode("span", { class: "nav-link-text" }, "Admin Menu")
                ], -1)),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    role: "switch",
                    id: "adminViewSwitch",
                    checked: _ctx.userFlagsStore.isAdminView,
                    onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleAdminView && _ctx.toggleAdminView(...args)))
                  }, null, 40, _hoisted_12)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _cache[7] || (_cache[7] = _createElementVNode("li", null, [
          _createElementVNode("hr", { class: "dropdown-divider" })
        ], -1)),
        _createElementVNode("li", null, [
          _createElementVNode("a", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.logout())),
            class: "dropdown-item"
          }, [...(_cache[6] || (_cache[6] = [
            _createElementVNode("i", { class: "fas fa-power-off text-red me-2" }, null, -1),
            _createElementVNode("span", { class: "nav-link-text" }, "Salir", -1)
          ]))])
        ])
      ])
    ])
  ]))
}